import { styled } from '@linaria/react'
import { MultiColumnsItemStyled } from '../../MultiColumns.styled'

export const MCItemDirectorsStarsSC = styled(MultiColumnsItemStyled)``
